import Vue from "vue";
import vAlert from "./vue-alert-component";
import veeValidate from "vee-validate";

Vue.use(veeValidate, {
  dictionary: {
    en: {
      attributes: require("@/plugins/locales/en")
    }
  }
});

Vue.use(vAlert);
Vue.component("v-404", () => import("@/views/auth/404.vue"));
Vue.component("page", () => import("@/components/global/page.vue"));
Vue.component("loading", () => import("@/components/global/loading.vue"));
Vue.component("date", () => import("@/components/global/datePicker.vue"));
Vue.component("score-card-summary", () =>
  import("@/views/pages/CSOs/scoreCardSummary.vue")
);
Vue.component("form-dialog", () =>
  import("@/components/global/formDialog.vue")
);
Vue.component("print-preview", () =>
  import("@/components/global/printPreview.vue")
);
